import React from 'react'
import img from '../assets/gadha.png'

const Loader = () => {
  return (
<div className="flex justify-center items-center min-h-screen bg-gray-100">
      <div
        className="w-24 h-24 bg-cover bg-center animate-spin"
        style={{ backgroundImage: `url(${img})` }}
      ></div>
    </div>
  )
}

export default Loader


